import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { RouterLink } from 'components/designSystem/Link/RouterLink'
import { supportFormPath } from 'components/page/Boarding/SupportForm/SupportForm.paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const SupportLink: FC = () => {
  const { locale } = useShallowEqualSelector(
    ({ systemReducer: { locale } }) => ({ locale })
  )

  return (
    <RouterLink
      to={mergeAllUrls(locale, supportFormPath)}
      data-name="support-action"
    >
      <FormattedMessage id="app.support" defaultMessage="Служба поддержки" />
    </RouterLink>
  )
}
